exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".infinite-scroll[data-v-64575a14]{overflow-y:scroll;-webkit-overflow-scrolling:touch}", ""]);

// exports
